import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Box, Grid, Tooltip, Divider } from '@mui/material';
import ProductExpandCollapseHeading from './ProductExpandCollapseHeading';
import ProductExpandCollapseBodyProductInfo from './ProductExpandCollapseBodyProductInfo';
import ProductExpandCollapseBodyComposition from './ProductExpandCollapseBodyComposition';
import ProductStatus from 'components/product/components/ProductStatus';

export default function ProductExpandCollapse({ productObj }) {
    const [expanded, setExpanded] = useState(true);
    return (
        <>
            <ProductExpandCollapseHeading
                heading={productObj.title}
                expanded={expanded}
                setExpanded={setExpanded}
                status={productObj.statusname}
                overallstatusid={productObj.overallstatusid}
            />
            {expanded ?
                <>
                    <Grid
                        container
                        direction="row"
                        sx={{
                            justifyContent: "space-between",
                            alignItems: "center",
                            backgroundColor:'#fafafa',
                            width:'100%'
                        }}
                    
                        >
                        <Grid item lg={12} xs={12} sx={{borderBottom:'1px solid #91d5ff'}}>
                            <ProductExpandCollapseBodyProductInfo productObj={productObj} />
                        </Grid>
                        
                        {/* <Grid item lg={12} xs={12} >
                            <ProductExpandCollapseBodyComposition productObj={productObj} />
                        </Grid> */}
                        {productObj.statusname!=='DRAFT' && 
                        productObj.statusname!=='REFERRED BACK' && 
                        productObj.statusname!=='MD APPROVAL'&& 
                        productObj.statusname!=='ACCOUNTS APPROVAL' ?
                        <Grid item lg={12} xs={12} sx={{borderBottom:'1px solid #91d5ff'}}>
                            <ProductStatus productObj={productObj} />
                        </Grid>
                        :<></>}
                    </Grid>
                </>
                : <></>
            }
        </>


    )
}